import CommonNouns from "../../components/ClassOne/English/CommonNoun";
import ProperNouns from "../../components/ClassOne/English/ProperNoun";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/english/nouns/common-nouns", title: "Common Nouns", component: CommonNouns },
    { url: "/class-one/english/nouns/proper-nouns", title: "Proper Nouns", component: ProperNouns },
];


export default topics;